<script>
	const pcWidth = 1920;
	const moWidth = 640;
	import {shortcut} from './shortcut.js'
	import { onMount } from "svelte";
	import Home from "./Pages/Home.svelte";
	import Konnect from "./Pages/Konnect.svelte";
	import Kct from "./Pages/Kct.svelte";
	import NftMarket from "./Pages/NftMarket.svelte";
	import Airdrop from "./Pages/Airdrop.svelte";
	import NewYork from "./Pages/NewYork.svelte";
	import Staking from "./Components/Staking/Staking.svelte";
	import Kbw from "./Pages/Kbw.svelte";
	import SvelteSeo from "svelte-seo";
	import { navigate, Router, Link, Route } from "svelte-routing";
	import { GoogleAnalytics } from '@beyonk/svelte-google-analytics';
	import { store } from './store.js';

	export let url = "";

	let iw, ow, page;

	function updateStore() {
		let updates = {};
		let targetWidth, r;
		
		if(window.innerWidth > 640) targetWidth = pcWidth;
		if(window.innerWidth <= 640) targetWidth = moWidth;

		r = window.innerWidth / targetWidth;
		
		updates = {
			r: r,
			targetWidth: targetWidth,
			type: targetWidth === pcWidth ? 'pc': 'mo'
		}

		store.update((s) => ({ ...s, ...updates }))
	}

	onMount(() => {		
		updateStore();
		window.addEventListener('resize', updateStore);
		
		return () => {
			window.removeEventListener('resize', updateStore);
		}
	});


	onMount(() => {
		return window.location.href = 'https://konnect-world.com';
		// if(window && window.location) {
		// 	let { pathname } = window.location;
		// 	let paths = pathname.split('/');

		// 		if(paths.length === 1) return navigate('/en', { replace: true });

		// 		if(paths.length >= 2) {
		// 			if(paths[1] !== 'en' && paths[1] !== 'kr' && paths[1] !== 'cn' && paths[1] !== 'vn') {
		// 				return navigate('/en', { replace: true });
		// 			}
		// 			store.update((s) => ({...s, locale: paths[1]}));
		// 			return;
		// 		}
		// 		if(pathname === '/') {
		// 			navigate('/en', { replace: true });
		// 			return;
		// 		}
		// 		if(pathname.length === 3 && (pathname.substring(0,3) !== '/en' && pathname.substring(0,3) !== '/kr' && pathname.substring(0,3) !== '/vn')) {
		// 			navigate('/en', { replace: true });
		// 			return;
		// 		}

		// 		if(pathname.length >= 4 && (pathname.substring(0,4) !== '/en/' && pathname.substring(0,4) !== '/kr/' && pathname.substring(0,4) !== '/vn/')) {
		// 			navigate('/en', { replace: true });
		// 			return;
		// 		}
			
		// }
		if(window && window.location) {
			let { pathname } = window.location;
			let paths = pathname.split('/');

			if(paths.length === 1) return navigate('/en', { replace: true });

			if(paths.length >= 2) {
				if(paths[1] !== 'en' && paths[1] !== 'kr' && paths[1] !== 'cn' && paths[1] !== 'vn') {
					return navigate('/en', { replace: true });
				}
				store.update((s) => ({...s, locale: paths[1]}));
				return;
			}
			if(pathname === '/') {
				navigate('/en', { replace: true });
				return;
			}
			if(pathname.length === 3 && (pathname.substring(0,3) !== '/en' && pathname.substring(0,3) !== '/kr' && pathname.substring(0,3) !== '/vn')) {
				navigate('/en', { replace: true });
				return;
			}

			if(pathname.length >= 4 && (pathname.substring(0,4) !== '/en/' && pathname.substring(0,4) !== '/kr/' && pathname.substring(0,4) !== '/vn/')) {
				navigate('/en', { replace: true });
				return;
			}
			
		}

	})
</script>

<GoogleAnalytics properties={[ 'G-HEJ3WHC4W9' ]} />
<svelte:window 
	use:shortcut={{
		control: true, alt: false, code: 'Digit1', 
		callback: () => store.update(s => ({...s, isDev: !$store.isDev}))
	}} 
	use:shortcut={{
		control: true, alt: false, code: 'Digit2', 
		callback: () => store.update(s => ({...s, showMover: false, showGrabber:false, showColor: $store.isDev ? !$store.showColor : false}))
	}} 
	use:shortcut={{
		control: true, alt: false, code: 'Digit3', 
		callback: () => store.update(s => ({...s, showColor: false, showGrabber:false, showMover: $store.isDev ? !$store.showMover : false}))
	}} 
	use:shortcut={{
		control: true, alt: false, code: 'Digit4', 
		callback: () => store.update(s => ({...s, showColor: false, showMover:false, showGrabber: $store.isDev ? !$store.showGrabber : false}))
	}} 
	use:shortcut={{
		control: true, alt: false, code: 'Digit5', 
		callback: () => {
			let sections = document.querySelectorAll(".section");
			let styles = { };
			for(let i = 0; i < sections.length; ++i) {
				let section = sections[i];
				let name = section.getAttribute('data-name');
				if(!styles[name]) styles[name] = {};
				
				if(section.style.top) {
					if(!styles[name]['top']) styles[name]['top'] = {}
					
					styles[name]['top'] = section.style.top;
				}

				if(section.style.left) {
					if(!styles[name]['left']) styles[name]['left'] = {}
					
					styles[name]['left'] = section.style.left;
				}

				if(section.style.width) {
					if(!styles[name]['width']) styles[name]['width'] = {}
					
					styles[name]['width'] = section.style.width;
				}
			}
			
			if(navigator.clipboard) {
				navigator.clipboard.writeText(JSON.stringify(styles))
					.then(() => {
					console.log("Text copied to clipboard...")
				})
					.catch(err => {
					console.log('Something went wrong', err);
				})
			
			}
			// console.log(JSON.stringify(styles, null, "\t"))
		}
	}} 
	bind:innerWidth={iw} 
	bind:outerWidth={ow}
/>

<SvelteSeo
  title="Konnect-KCT"
  description="Konnect builds a platform ecosystem that connects the virtual and the real."
  keywords="KCT, Konnect, Crypto, Blockchain, De-fi, NFT, PFP NFT, Ethereum, Multi-chain, E-commerce, NFT marketplace, 커넥트, 코넥트, connect, 커넥트멤버십, 얼라이언스, 커넥트할인, 블록체인, 듀먼, 멤버십, NFT마켓, NFT마켓플레이스, 커넥트신라, 커넥트롯데호텔"
  canonical="https://konnect.finance"

  twitter={{
    site: "@KONNECT_KCT",
    title: "Konnect-KCT",
    description: "Konnect builds a platform ecosystem that connects the virtual and the real.",
    image: "https://konnect.finance/images/logo.png",
    imageAlt: "Konnect-KCT",
  }}

  openGraph={{
    title: 'Konnect-KCT',
    description: 'Konnect builds a platform ecosystem that connects the virtual and the real.',
    url: 'https://konnect.finance',
    type: 'website',
    images: [
      {
        url: 'https://konnect.finance/images/logo.png',
        width: 650,
        height: 650,
        alt: 'Konnect-KCT'
      }
	]
  }}
/>

<Router {url}>
	<Route let:params path=":lang/staking" component={Staking} />
	<Route let:params path=":lang/event/kbw" component={Kbw} />
	<!-- <Route let:params path=":lang/event/nyc" component={NewYork} /> -->
	<!-- <Route let:params path=":lang/event/airdrop" component={Airdrop} /> -->
	<Route let:params path=":lang/nft" component={NftMarket} />
	<Route let:params path=":lang/konnect" component={Konnect} />
	<Route let:params path=":lang/kct" component={Kct} />
	<Route let:params path=":lang" component={Home} />
	<Route path="/"><Home /></Route>	
	<Route component={Home} />
</Router>
